<div class="element-wrapper" [style]="wrapperStyles()">
  @if (labelEnabled()) {
    <blaze-element-header
      [color]="props?.style?.general?.title?.color1"
      [fontFamily]="props?.style?.titleBlock?.fontFamily"
      [fontSize]="props?.style?.titleBlock?.fontSize"
      [fontStyle]="props?.style?.titleBlock?.fontStyle"
      [fontWeight]="props?.style?.titleBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.titleBlock?.iconSize"
      [style]="headerStyles()"
      class="mb-16"
    >
      {{ labelText() }}
    </blaze-element-header>
  }
  @if (isSourceBound()) {
    <section class="flex flex-col gap-24">
      @for (config of visibleSchedules(); track config.id; let first = $first) {
        <blaze-availability-schedule
          [model]="config"
          [isFirst]="first"
          [defaultTimeSlot]="defaultTimeSlot()"
          [visibleDays]="visibleDays()"
          [errors]="schedulesErrors()[$index]"
          [hasMissingConfig]="hasMissingConfig()"
          (copySchedule)="onScheduleCopy($index)"
          (deleteSchedule)="onScheduleDelete(config.id)"
          (validateSchedule)="onScheduleValidate($event, $index)"
          (saveChanges)="onScheduleUpdate($event)"
        />
      }
      <blaze-element-loading-indicator [isVisible]="isSaving()" />
      <div>
        <button
          class="button flex rounded gap-8 p-8 items-center whitespace-nowrap bg-base-white text-11 font-semibold border border-base-transparent hover:border-a-12"
          blazeClickable
          [disabled]="hasChanges()"
          matTooltipPosition="above"
          blazeTooltip="{{
            hasChanges()
              ? 'Save your schedule before adding a new range'
              : 'Adds a new schedule for a specific date range'
          }}"
          (click)="onScheduleCopy(-1)"
        >
          <mat-icon svgIcon="icon_add_24" class="icon-24" />
          <span class="pt-3">NEW SCHEDULE</span>
        </button>
      </div>
    </section>
  } @else {
    <div class="hint-generate">
      <span class="description">
        To configure availability, choose your source data in the properties panel.
      </span>
      <button class="bd-btn border-a-12 mt-16">OPEN AVAILABILITY PROPERTY PANEL</button>
    </div>
  }
</div>
